import { type Repair } from '@service-initiation/tech-care-data-access-tech-care-services';

export const appendCustomerMessage = (
  customerMessage?: string,
  perils?: Repair[]
) => {
  const userMessage = customerMessage ? customerMessage : '';
  const delimiterMessage = perils ? ' - Selected Perils - ' : '';
  const perilMessage = perils
    ? perils.map((dmg) => dmg?.repairType?.symptom)
    : '';

  return userMessage + delimiterMessage + perilMessage;
};
